// Hook listy własnych ofert klienta - GET /sales-crm/my-offers

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmMyOfferListItem {
  id: number;
  number: string | null;
  status: number | null;
  // Backend zwraca w snake_case (mechanika AbstractGetListUiApiService).
  status_formatted: string | null;
  actual_version_id: number | null;
  sys_insert_date: string | null;
  is_periodic: boolean | null;
  valid_until: string | null;
}

export interface ISalesCrmMyOffersResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: ISalesCrmMyOfferListItem[];
}

export interface IGetMyOffersParams {
  page?: number;
  limit?: number;
  status?: number;
  search_keyword?: string;
  /** true = tylko okresowe; false = tylko jednorazowe (dedykowane); undefined = wszystkie. */
  is_periodic?: boolean;
}

export const getSalesCrmMyOffersQueryKey = (params?: IGetMyOffersParams) =>
  ['sales-crm', 'my-offers', params] as const;

const getSalesCrmMyOffers = (
  params?: IGetMyOffersParams
): Promise<ISalesCrmMyOffersResponse> => {
  const queryParams: Record<string, number | string> = {};
  if (params?.page) queryParams.page = params.page;
  if (params?.limit) queryParams.limit = params.limit;
  if (params?.status) queryParams.status = params.status;
  if (params?.search_keyword) queryParams.search_keyword = params.search_keyword;
  if (params?.is_periodic !== undefined) queryParams.isPeriodic = params.is_periodic ? '1' : '0';
  return axios.get('/sales-crm/my-offers', { params: queryParams });
};

export const useGetSalesCrmMyOffers = (
  params?: IGetMyOffersParams,
  options?: UseQueryOptions<ISalesCrmMyOffersResponse, IError>
) =>
  useQuery<ISalesCrmMyOffersResponse, IError>(
    getSalesCrmMyOffersQueryKey(params),
    () => getSalesCrmMyOffers(params),
    options
  );
